import React from 'react'
import styled from 'styled-components'
import OnwardSharingCheckbox from 'components/OnwardSharingCheckbox'
import SkeletonBar from 'components/SkeletonBar'

export const STAFF_NOTE =
  'Requests to open documents you upload are decided by the building’s client organisation’s Super Admins, so there is nothing to choose here.'
export const ORGANISATION_NOTE =
  'Requests to open documents you upload are decided by your organisation’s Super Admins, so there is nothing to choose here.'

const UploadOnwardSharing = ({ isStaffUploader, organisationRoutes, checked, onChange }) => (
  <Wrapper>
    {isStaffUploader && <OnwardSharingCheckbox appliesNote={STAFF_NOTE} />}
    {!isStaffUploader && organisationRoutes === null && (
      <SkeletonBar aria-hidden='true' data-testid='onward-skeleton' $width='40%' $height='20px' />
    )}
    {!isStaffUploader && organisationRoutes === true && (
      <OnwardSharingCheckbox appliesNote={ORGANISATION_NOTE} />
    )}
    {!isStaffUploader && organisationRoutes === false && (
      <div data-tour-id='upload.onward-sharing'>
        <OnwardSharingCheckbox checked={checked} onChange={onChange} viewerIsUploader />
        <Hint>You can change this for a single file in its row below.</Hint>
      </div>
    )}
  </Wrapper>
)

export default UploadOnwardSharing

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 14px 18px;
  margin: 0 20px 12px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
`

const Hint = styled.p`
  margin: 4px 0 0;
  font-size: 15px;
  line-height: 1.5;
  color: #475467;
`
